module.exports = __webpack_public_path__ + "static/media/osu-collection-manipulator.6b51c016.md";